if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      const products = getCookie('foxtheme:recently-viewed')
      if (!products) {
        this.setAttribute('hidden', true)
      } else {
        this.init(products)
      }
    }

    init(products) {
      this.productNodes = {}
      this.products = Array.from(new Set(JSON.parse(products))).reverse()
      this.productContainer = this.querySelector('.f-recently-viewed-flickity')
      this.enableSlider = this.productContainer.dataset.enableSlider === 'true'
      this.section = this.closest('.f-recently-viewed')
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this.section);

        this.fetchProducts()
      }

      new IntersectionObserver(handleIntersection.bind(this.section), {rootMargin: '0px 0px 400px 0px'}).observe(this.section);
    }

    async fetchProducts() {
      const promises = this.products.map(async handle => {
        const productUrl = `${window.FoxThemeSettings.base_url}products/${handle}`
        const prodHTML = await fetchSection('product-card-grid', {url: productUrl}).catch(() => {})
        if (prodHTML) {
          this.productNodes[handle] = prodHTML.querySelector('.f-column')
        }
      })

      await Promise.all(promises)

      this.renderProducts()
    }

    renderProducts() {
      this.products.forEach(hdl => {
        const node = this.productNodes[hdl]
        node && this.productContainer.appendChild(node);
      })
      if (this.enableSlider && !FoxThemeSettings.isMobile) {
        this.slider = new window.FoxTheme.Slider(this.productContainer)
      }
      const column = this.productContainer.dataset.sliderColumns
      if (this.products.length <= Number(column) && typeof this.slider.instance === 'object') {
        this.slider.instance.destroy();
        this.classList.add("flickity-destroyed");
        this.slider.instance.off("pointerMove");
        this.slider.instance.off("pointerUp");
      }
      this.sendTrekkieEvent(this.products.length)
      __reInitTooltip(this.productContainer);
    }

    sendTrekkieEvent(numberProducts) {
      if (
        !window.ShopifyAnalytics ||
        !window.ShopifyAnalytics.lib ||
        !window.ShopifyAnalytics.lib.track
      ) {
        return
      }
      let didPageJumpOccur = this.getBoundingClientRect().top <= window.innerHeight

      window.ShopifyAnalytics.lib.track('Recently Viewed Products Displayed', {
        theme: Shopify.theme.name,
        didPageJumpOccur: didPageJumpOccur,
        numberOfRecommendationsDisplayed: numberProducts
      })
    }
  });
}
